import type { ReactElement } from 'react';

import styles from './DiagnosticsButtons.module.css';

/**
 * Перенос `_TextButton` и `_ActionButton` из `diagnostics_page.dart`.
 *
 * Оба жили в одном файле со страницей и нигде больше не используются —
 * здесь они лежат вместе по той же причине.
 */

export interface DiagnosticsTextButtonProps {
  readonly label: string;
  readonly onPressed: () => void;
  readonly selected?: boolean;
}

/** Кнопка подвала: «Скопировать», «Очистить» и фильтры журнала. */
export function DiagnosticsTextButton({
  label,
  onPressed,
  selected = false,
}: DiagnosticsTextButtonProps): ReactElement {
  const className = [styles.text, selected ? styles.textSelected : null]
    .filter(Boolean)
    .join(' ');
  return (
    <button type="button" className={className} onClick={onPressed}>
      <span className={styles.textLabel}>{label}</span>
    </button>
  );
}

export interface DiagnosticsActionButtonProps {
  readonly label: string;
  readonly onPressed: () => void;
  readonly hint?: string;
  /** Ждёт второго нажатия. */
  readonly armed?: boolean;
  readonly danger?: boolean;
  readonly busy?: boolean;
}

/** Подпись кнопки: занятая, взведённая и обычная — три разных текста. */
function actionLabel(label: string, busy: boolean, armed: boolean): string {
  if (busy) return `${label}…`;
  return armed ? `Нажмите ещё раз: ${label}` : label;
}

/** Кнопка действия в панели состояния. */
export function DiagnosticsActionButton({
  label,
  onPressed,
  hint,
  armed = false,
  danger = false,
  busy = false,
}: DiagnosticsActionButtonProps): ReactElement {
  // `accent = danger || armed ? AppColors.cD75B5B : Colors.white`
  const accent = danger || armed ? styles.labelAccent : null;
  const className = [styles.action, armed ? styles.actionArmed : null]
    .filter(Boolean)
    .join(' ');
  return (
    <button
      type="button"
      className={className}
      // `onTap: busy ? null : onPressed`
      disabled={busy}
      onClick={onPressed}
    >
      <span className={[styles.actionLabel, accent].filter(Boolean).join(' ')}>
        {actionLabel(label, busy, armed)}
      </span>
      {hint !== undefined && <span className={styles.hint}>{hint}</span>}
    </button>
  );
}
